
export default {
  state:{
    asideWidth: 160,
    noteList: ['s89v', '3243', 'Fr53', 'LKfg', 'fds0', 'dfDR', '343d', 'sfD2', 'K8L3', '43FD'],
    msgText: ''
  },
  mutations: {
    SET_MSG_TEXT (state, msg){
      state.msgText = msg
    },
    SET_ASIDE_W (state, w) {
      state.asideWidth = w
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/globe.js